import React from "react";
import ArrowPrev from "../../icons/ArrowPrev";
import ArrowNext from "../../icons/ArrowNext";

export interface QuizPaginationProps {
  canGoPrev: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export const QuizPagination: React.FC<QuizPaginationProps> = ({
  canGoPrev,
  onPrev,
  onNext,
}) => (
  <div className="quiz-pagination">
    <button
      type="button"
      className="quiz-pagination-prev"
      name="prev"
      onClick={onPrev}
      style={{ display: canGoPrev ? undefined : "none" }}
      aria-label="Previous step"
    >
      <ArrowPrev />
    </button>
    <button
      type="button"
      className="quiz-pagination-next"
      name="next"
      onClick={onNext}
      aria-label="Next step"
    >
      <ArrowNext />
    </button>
  </div>
);
